import { useState, useCallback } from 'react';
import { showAlert } from '../redux/alertSlice';
import { SEVERITIES } from '../data/constants';
import { useDispatch } from 'react-redux';
import { logHandledError } from '../utils/errorLogger';

type ApiFunction<TParams, TResult> = (params: TParams) => Promise<TResult>;

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();
  
   const executeApi = useCallback(async <TParams, TResult>(
    apiFunction: ApiFunction<TParams, TResult>,
    params: TParams
  ): Promise<TResult | null> => {
    setLoading(true);
    setError(null);

    try {
      const result = await apiFunction(params);
      return result;
    } catch (err) {
        const message = (err as Error).message;
        setError(message);
        // Handled here, so it never reaches ErrorBoundary or
        // window.onunhandledrejection — log it or it is lost to the Error Log.
        logHandledError(message, (err as Error).stack ?? "");
         dispatch(
                showAlert({
                  message: message,
                  severity: SEVERITIES.ERROR,
                })
              );
        return null;
      } finally {
        setLoading(false);
      }
    }, [dispatch]);
  

    return { loading, error, executeApi };
};

export default useApi;

